
import SettingsGrid from './grid'
import SettingsMenu from './grid/components/settings-menu'

export default {
  SettingsGrid,
  SettingsMenu
}
